import { render, staticRenderFns } from "./AdminSystemSettings.vue?vue&type=template&id=b29d29ce"
import script from "./AdminSystemSettings.vue?vue&type=script&lang=js"
export * from "./AdminSystemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports